import { OnboardingHOC } from 'testania';
import React from 'react';

import { useAnalytics, usePreloadNextPage } from 'hooks';

import ObSocialProofLibContainer from 'containers/OnboardingContainers/ObSocialProofLibContainer';

import { ICommonPageProps } from 'types/pages/ondoardignPages/commonTypes';

import { getContent } from './config';

function ObSocialProof({ toNextPage, getNextPage }: ICommonPageProps) {
    const { customData } = useAnalytics();

    usePreloadNextPage({ getNextPage });

    const handleToNextPage = () => {
        customData('ob_social_proof__continue__click');

        toNextPage();
    };

    return <ObSocialProofLibContainer content={getContent()} toNextPage={handleToNextPage} />;
}

export default OnboardingHOC(ObSocialProof);
